import {Spinner} from "react-bootstrap";

export function LoadingSpinner() {
    return (
        <div className="d-flex justify-content-center py-5">
            <Spinner role="status"><span className="visually-hidden">Loading…</span></Spinner>
        </div>
    );
}
